import React from 'react';
import { BrandTag } from '@urbantxt/tag';
import {
  TAG_COLOR_BLUE,
  TAG_COLOR_GREEN,
  TAG_COLOR_ORANGE,
  TAG_COLOR_RED,
} from 'constants/colors';
import styles from './UserTypeTag.module.scss';

export type TxterProfileType = 'alumni' | 'txter';

export interface IUserTypeTagProps {
  type: any;
  size: 'lg' | 'md' | 'sm' | undefined;
}

/** Darker than TAG_COLOR_GREEN so white label meets WCAG contrast on tag background */
const SUPER_ADMIN_TAG_BG = '#2e7d32';

const getColor = (type: any) => {
  if (type === 'super-admin') return SUPER_ADMIN_TAG_BG;

  if (type === 'staff' || type === 'admin') return TAG_COLOR_GREEN;

  if (type === 'user') return TAG_COLOR_BLUE;

  if (type === 'guest') return TAG_COLOR_ORANGE;

  if (type === 'scla-app-reader') return TAG_COLOR_ORANGE;

  return TAG_COLOR_RED;
};

export function UserTypeTag(props: IUserTypeTagProps) {
  const { type, size } = props;
  return (
    <BrandTag
      className={styles.tag}
      backgroundColor={getColor(type)}
      size={size}
    >
      {type}
    </BrandTag>
  );
}
